import packageJson from '../../package.json'

export const environment = {
  production        : false,
  defaultLanguage   : 'en',
  availableLanguages: [ 'en', 'fr', 'de', 'es', 'it', 'pl', 'pt-PT', 'pt'  ],
  features          : {
    auth                        : true,
    readings                    : true,
    reports                     : true,
    watches                     : true,
    waste                       : true,
    customizableCharts          : true,
    periodBasedTimeNavigation   : true,
    versionlessReadingForms     : true,
    editableDevicesOperationDate: true,
    newAuthFrontend             : true,
    remoteAccess                : true,
  },
  featureFlagBackdoorSecretHash: '2df9233b1efccbadbf830104613cde56a62f87f8a22e65840f7e0d43e91f98b',
  version                      : `${packageJson.version}-dev`
}
